import {useCallback, useEffect, useState} from 'react';
import throttle from 'lodash.throttle';
import cssBreakpoints from '@/styles/breakpoints.scss';

const RESIZE_TIMEOUT = 300;

export const useBreakpoints = () => {
  const [screenWidth, setScreenWidth] = useState(0);

  const handleResize = throttle(
    useCallback(() => setScreenWidth(window.innerWidth), []),
    RESIZE_TIMEOUT,
  );

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  const breakpoints = Object.keys(cssBreakpoints)
    .map((key) => [key, parseInt(cssBreakpoints[key], 10)])
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  return {
    screenWidth,
    breakpoints: Object.keys(breakpoints).reduce((acc, breakpoint) => {
      acc[breakpoint] =
        screenWidth > 0 && screenWidth < breakpoints[breakpoint];
      return acc;
    }, {}),
  };
};
